(function(){
'use strict';
/* ── keep full-bleed sections on the same left edge as .rail ── */
const syncScrollbar = () => {
  const width = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--sbw', `${Math.max(0, width)}px`);
};
syncScrollbar();
window.addEventListener('resize', syncScrollbar);

/* ── mobile nav ─────────────────────────────────────────── */
const menuButton = document.querySelector('.menu');
const mobileNav = document.querySelector('.mobile-nav');

function closeMenu() {
  menuButton?.setAttribute('aria-expanded', 'false');
  if (mobileNav) mobileNav.hidden = true;
  document.body.style.overflow = '';
}

menuButton?.addEventListener('click', () => {
  const opening = menuButton.getAttribute('aria-expanded') !== 'true';
  menuButton.setAttribute('aria-expanded', String(opening));
  mobileNav.hidden = !opening;
  document.body.style.overflow = opening ? 'hidden' : '';
});

mobileNav?.querySelectorAll('a').forEach(link => link.addEventListener('click', event => {
  const selector = link.getAttribute('href');
  closeMenu();
  if (selector?.startsWith('#') && selector.length > 1) {
    event.preventDefault();
    requestAnimationFrame(() => {
      document.querySelector(selector)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', selector);
    });
  }
}));

/* ── marquees ────────────────────────────────────────────
   A -50% shift only looks seamless when one set is already wider
   than the viewport. On a wide screen a single set ran out and left
   a blank gap, so clone the set until the track covers viewport +
   one set, then translate by exactly one set width. */
function buildMarquee(track) {
  const source = track.firstElementChild;
  if (!source) return;
  track.replaceChildren(source);

  const setWidth = source.getBoundingClientRect().width;
  if (!setWidth) return;

  const copies = Math.ceil((window.innerWidth + setWidth) / setWidth) + 1;
  for (let i = 1; i < copies; i++) {
    const clone = source.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  }

  const pxPerSecond = Number(track.dataset.marqueeSpeed) || 62;
  track.style.animation = 'none';
  track.getBoundingClientRect();               // force reflow so the restart takes
  track.style.setProperty('--shift', `${setWidth}px`);
  track.style.animation = `marquee ${setWidth / pxPerSecond}s linear infinite`;
}

/* the review wall has two rows; the second runs backwards */
function buildWall(set) {
  const row = set.parentElement;
  const copies = Math.ceil((window.innerWidth + set.getBoundingClientRect().width) / set.getBoundingClientRect().width) + 1;
  const track = document.createElement('div');
  track.className = 'wall__track';
  track.style.display = 'flex';
  track.style.width = 'max-content';
  const width = set.getBoundingClientRect().width;
  if (!width) return;
  row.replaceChildren(track);
  for (let i = 0; i < copies; i++) {
    const clone = set.cloneNode(true);
    if (i) clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  }
  const back = row.classList.contains('wall__row--back');
  track.style.setProperty('--shift', `${width}px`);
  track.style.animation = `${back ? 'marquee-back' : 'marquee'} ${width / 26}s linear infinite`;
}

const wallSets = [...document.querySelectorAll('[data-marquee-set]')].map(set => set.cloneNode(true));
const wallRows = [...document.querySelectorAll('.wall__row')];
const buildWalls = () => wallRows.forEach((row, i) => {
  const fresh = wallSets[i].cloneNode(true);
  row.replaceChildren(fresh);
  buildWall(fresh);
});

const marquees = [...document.querySelectorAll('[data-marquee]')];
const buildAll = () => { marquees.forEach(buildMarquee); buildWalls(); };

if (document.fonts && document.fonts.ready) document.fonts.ready.then(buildAll);
else window.addEventListener('load', buildAll);
buildAll();

let marqueeTimer;
window.addEventListener('resize', () => {
  clearTimeout(marqueeTimer);
  marqueeTimer = setTimeout(buildAll, 220);
});

/* ── comparison: one rival at a time ─────────────────────── */
const RIVALS = {
  greens: {
    name: 'Greens powder',
    eyebrow: 'What you have now',
    note: 'Products in these categories vary. Compare the ingredients, serving size and Nutrition Facts on your own product.',
    rows: [
      ["Ingredients", "Five, printed by weight", "Check your product label"],
      ["Made from", "Whole foods, roasted", "Ingredients vary by product"],
      ["Fiber", "Three plant sources", "Check the Nutrition Facts panel"],
      ["Added sugar", "0 g", "Check the added-sugars line"],
      ["Caffeine", "0 mg", "Check the product and serving size"],
      ["Per serving", "$1.17, then $1.63", "Compare your price and serving size"],
      ["Taste", "Toasted, malty", "Varies by product and preparation"],
    ],
  },
  shake: {
    name: 'Meal-replacement shake',
    eyebrow: 'What you have now',
    note: 'Products in these categories vary. Compare the ingredients, serving size and Nutrition Facts on your own product.',
    rows: [
      ["Ingredients", "Five, printed by weight", "Check your product label"],
      ["Made from", "Whole foods, roasted", "Ingredients vary by product"],
      ["Fiber", "Three plant sources", "Check the Nutrition Facts panel"],
      ["Added sugar", "0 g", "Check the added-sugars line"],
      ["Sits like", "A light glass", "Experience varies by person"],
      ["Per serving", "$1.17, then $1.63", "Compare your price and serving size"],
      ["Taste", "Toasted, malty", "Varies by product and preparation"],
    ],
  },
  coffee: {
    name: 'Coffee & a bar',
    eyebrow: 'What you have now',
    note: 'Products in these categories vary. Compare the ingredients, serving size and Nutrition Facts on your own product.',
    rows: [
      ["Ingredients", "Five, printed by weight", "Check your product label"],
      ["Made from", "Whole foods, roasted", "Ingredients vary by product"],
      ["Fiber", "Three plant sources", "Check the Nutrition Facts panel"],
      ["Added sugar", "0 g", "Check the added-sugars line"],
      ["By eleven", "Still holding", "Experience varies by person"],
      ["Per serving", "$1.17, then $1.63", "Compare your price and serving size"],
      ["Taste", "Toasted, malty", "Varies by product and preparation"],
    ],
  },
};

const vsRows = document.querySelector('[data-vs-rows]');
const vsName = document.querySelector('[data-vs-name]');
const vsEyebrow = document.querySelector('[data-vs-eyebrow]');
const vsNote = document.querySelector('[data-vs-note]');

function renderRival(key) {
  const rival = RIVALS[key];
  if (!rival || !vsRows) return;

  vsName.textContent = rival.name;
  vsEyebrow.textContent = rival.eyebrow;
  if (vsNote) vsNote.textContent = rival.note;

  vsRows.replaceChildren(...rival.rows.map(([label, mine, theirs]) => {
    const row = document.createElement('div');

    const dt = document.createElement('dt');
    dt.textContent = label;

    const good = document.createElement('dd');
    good.className = 'duel__mine-cell';
    good.innerHTML = '<i aria-hidden="true">✓</i>';
    good.append(Object.assign(document.createElement('b'), { textContent: mine }));

    const bad = document.createElement('dd');
    bad.className = 'duel__theirs-cell';
    bad.innerHTML = '<i aria-hidden="true">·</i>';
    bad.append(Object.assign(document.createElement('span'), { textContent: theirs }));

    row.append(dt, good, bad);
    return row;
  }));
}

const switchButtons = [...document.querySelectorAll('.switch button')];
switchButtons.forEach((button, index) => {
  button.tabIndex = index === 0 ? 0 : -1;
  button.addEventListener('keydown', event => {
    const offset = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
    const next = event.key === 'Home' ? switchButtons[0] : event.key === 'End' ? switchButtons[switchButtons.length - 1] : offset ? switchButtons[(index + offset + switchButtons.length) % switchButtons.length] : null;
    if (next) { event.preventDefault(); next.focus(); next.click(); }
  });
});
switchButtons.forEach(button => button.addEventListener('click', () => {
  switchButtons.forEach(other => { other.setAttribute('aria-selected', String(other === button)); other.tabIndex = other === button ? 0 : -1; });
  renderRival(button.dataset.vs);
}));
renderRival('greens');

/* ── product gallery ────────────────────────────────────── */
document.querySelectorAll('[data-gallery]').forEach(gallery => {
  const frame = gallery.querySelector('.gallery__main');
  const firstImage = frame?.querySelector('img');
  const thumbs = [...gallery.querySelectorAll('.thumb')];
  const rail = gallery.querySelector('.gallery__thumbs');
  if (!firstImage || thumbs.length < 2 || !rail) return;
  const count = thumbs.length;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const track = document.createElement('div');
  track.className = 'gallery__track';
  track.tabIndex = 0;
  track.setAttribute('role', 'group');
  track.setAttribute('aria-label', 'Product images. Use left and right arrow keys to navigate.');
  const status = document.createElement('span');
  status.className = 'gallery__status';
  status.setAttribute('aria-live', 'polite');
  status.setAttribute('aria-atomic', 'true');
  const order = [count - 1, ...thumbs.map((_, index) => index), 0];
  const slides = order.map((index, position) => {
    const slide = document.createElement('div');
    slide.className = 'gallery__slide';
    slide.dataset.index = index;
    slide.style.backgroundImage = `url("${thumbs[index].querySelector('img').src}")`;
    const image = position === 1 ? firstImage : new Image();
    image.removeAttribute('id');
    image.width = image.height = 1600;
    image.alt = thumbs[index].dataset.alt || '';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.draggable = false;
    const show = () => slide.classList.add('is-loaded');
    image.addEventListener('load', show);
    image.addEventListener('error', () => {
      if (image.dataset.fallback) return;
      image.dataset.fallback = 'true';
      image.src = thumbs[index].querySelector('img').src;
    });
    image.src = thumbs[index].dataset.src;
    if (image.complete && image.naturalWidth) show();
    slide.append(image);
    slide.setAttribute('role', 'group');
    slide.setAttribute('aria-label', `Image ${index + 1} of ${count}`);
    slide.setAttribute('aria-hidden', 'true');
    track.append(slide);
    return slide;
  });
  frame.replaceChildren(track);
  gallery.append(status);
  gallery.classList.add('gallery--carousel');
  rail.setAttribute('role', 'group');
  rail.setAttribute('aria-label', 'Choose a product image');
  let active = 0;
  let settledIndex = 0;
  let resizing = false;
  let busy = false;
  let epoch = 0;
  const measureWidth = () => track.getBoundingClientRect().width;
  let width = measureWidth();
  let requestedPosition = 1;
  let timer;
  let frameRequest;
  let drag = null;
  let queue = [];
  const indexAt = position => (position - 1 + count) % count;
  const positionNow = () => Math.max(0, Math.min(count + 1, Math.round(track.scrollLeft / width)));
  const behavior = () => reducedMotion.matches ? 'auto' : 'smooth';
  const warm = index => slides.forEach(slide => {
    const distance = (Number(slide.dataset.index) - index + count) % count;
    if (distance <= 1 || distance === count - 1) slide.firstElementChild.loading = 'eager';
  });
  function paint(index, announce = false) {
    active = index;
    gallery.dataset.galleryIndex = String(index);
    thumbs.forEach((thumb, item) => {
      thumb.removeAttribute('role');
      thumb.classList.toggle('is-active', item === index);
      thumb.setAttribute('aria-pressed', String(item === index));
    });
    slides.forEach((slide, position) => {
      const selected = position === index + 1;
      slide.setAttribute('aria-hidden', String(!selected));
      if (selected) slide.firstElementChild.id = 'GalleryMain';
      else slide.firstElementChild.removeAttribute('id');
    });
    const thumb = thumbs[index];
    const delta = thumb.getBoundingClientRect().left - rail.getBoundingClientRect().left;
    if (delta < 0 || delta + thumb.offsetWidth > rail.clientWidth) {
      rail.scrollTo({ left: rail.scrollLeft + delta - (rail.clientWidth - thumb.offsetWidth) / 2, behavior: behavior() });
    }
    if (announce) status.textContent = `Image ${index + 1} of ${count}. ${thumb.dataset.alt || ''}`;
    warm(index);
  }
  function settle() {
    if (Math.abs(measureWidth() - width) > .01) { resizeGallery(); return; }
    if (drag || !width || resizing) return;
    if (busy && Math.abs(track.scrollLeft - requestedPosition * width) > 2) return;
    const position = positionNow();
    const index = indexAt(position);
    if (position === 0 || position === count + 1) {
      track.scrollTo({ left: (index + 1) * width, behavior: 'auto' });
    }
    busy = false;
    settledIndex = index;
    gallery.dataset.galleryMoving = 'false';
    paint(index, true);
    if (queue.length) navigate(queue.shift());
  }
  async function navigate(action) {
    if (busy) {
      if (action.index != null) queue = [action];
      else if (queue.length < count * 2) queue.push(action);
      return;
    }
    const index = action.index != null ? action.index : (active + action.step + count) % count;
    const position = action.step === -1 && active === 0 ? 0 : action.step === 1 && active === count - 1 ? count + 1 : index + 1;
    const operation = ++epoch;
    busy = true;
    gallery.dataset.galleryMoving = 'true';
    requestedPosition = position;
    const image = slides[position].firstElementChild;
    image.loading = 'eager';
    await Promise.race([image.decode().catch(() => {}), new Promise(resolve => setTimeout(resolve, 900))]);
    if (operation !== epoch) return;
    track.scrollTo({ left: position * width, behavior: behavior() });
    clearTimeout(timer);
    timer = setTimeout(settle, 160);
  }
  track.addEventListener('scroll', () => {
    if (Math.abs(measureWidth() - width) > .01) { resizeGallery(); return; }
    if (resizing) return;
    clearTimeout(timer);
    timer = setTimeout(settle, 130);
    if (frameRequest) return;
    frameRequest = requestAnimationFrame(() => {
      frameRequest = 0;
      const index = indexAt(positionNow());
      if (index !== active) paint(index);
    });
  }, { passive: true });
  track.addEventListener('scrollend', settle);
  track.addEventListener('keydown', event => {
    const action = event.key === 'ArrowLeft' ? { step: -1 } : event.key === 'ArrowRight' ? { step: 1 } : event.key === 'Home' ? { index: 0 } : event.key === 'End' ? { index: count - 1 } : null;
    if (action) { event.preventDefault(); navigate(action); }
  });
  track.addEventListener('pointerdown', event => {
    if (!event.isPrimary || event.button !== 0) return;
    epoch++;
    busy = false;
    queue = [];
    track.scrollTo({ left: track.scrollLeft, behavior: 'auto' });
    if (event.pointerType === 'mouse') {
      drag = { id: event.pointerId, x: event.clientX, left: track.scrollLeft };
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
      event.preventDefault();
    }
  });
  track.addEventListener('pointermove', event => {
    if (drag?.id === event.pointerId) track.scrollLeft = drag.left + drag.x - event.clientX;
  });
  function release(event) {
    if (drag?.id !== event.pointerId) return;
    const delta = drag.x - event.clientX;
    const initial = Math.round(drag.left / width);
    const position = Math.max(0, Math.min(count + 1, Math.abs(delta) > Math.min(65, width * .2) ? initial + Math.sign(delta) : initial));
    drag = null;
    track.classList.remove('is-dragging');
    if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
    busy = true;
    gallery.dataset.galleryMoving = 'true';
    requestedPosition = position;
    track.scrollTo({ left: position * width, behavior: behavior() });
    clearTimeout(timer);
    timer = setTimeout(settle, 160);
  }
  track.addEventListener('pointerup', release);
  track.addEventListener('pointercancel', release);
  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => navigate({ index })));
  [['prev', -1], ['next', 1]].forEach(([name, step]) => {
    const button = gallery.querySelector(`[data-gallery-${name}]`);
    if (!button) return;
    button.setAttribute('aria-label', step < 0 ? 'Previous product image' : 'Next product image');
    button.innerHTML = `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${step < 0 ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6'}"/></svg>`;
    button.addEventListener('click', () => navigate({ step }));
  });
  function resizeGallery() {
    const nextWidth = measureWidth();
    if (!nextWidth || Math.abs(nextWidth - width) < .01) return;
    resizing = true;
    epoch++;
    busy = false;
    queue = [];
    clearTimeout(timer);
    cancelAnimationFrame(frameRequest);
    frameRequest = 0;
    width = nextWidth;
    track.scrollTo({ left: (settledIndex + 1) * width, behavior: 'auto' });
    paint(settledIndex);
    gallery.dataset.galleryMoving = 'false';
    requestAnimationFrame(() => { resizing = false; });
  }
  new ResizeObserver(resizeGallery).observe(track);
  track.scrollTo({ left: width, behavior: 'auto' });
  paint(0);
  gallery.dataset.galleryMoving = 'false';
});

/* ── the offer: two radio groups, one price ──────────────
   .cad   — the delivery schedule. It only rewrites numbers inside the
            subscribe option, and selects it, because choosing a schedule is
            choosing to subscribe.
   .plans — subscribe vs one-time. It rewrites the button and the sticky bar.

   Naming rule, learned the hard way: a control's own values live on
   data-plan-* / data-cad-*, display nodes on data-sub-* / data-cta-*. Share a
   name between the two and a lookup can resolve to a radio and wipe its label. */
const planButtons = [...document.querySelectorAll('.plans > [role="radio"]')];
const cadenceButtons = [...document.querySelectorAll('.cad [role="radio"]')];
const subscribeOption = document.querySelector('[data-plan-role="sub"]');
const buyColumn = document.querySelector('.buycol');

const setText = (selector, value) => {
  const node = document.querySelector(selector);
  if (node && value != null) node.textContent = value;
};

const applyPlan = button => {
  planButtons.forEach(option => option.setAttribute('aria-checked', String(option === button)));
  buyColumn?.classList.toggle('is-once', button !== subscribeOption);

  const { planToday, planDays } = button.dataset;
  setText('[data-cta-price]', planToday);
  setText('[data-sticky-price]', `${planToday} today`);
  setText('[data-sticky-days]', planDays);
};

const applyCadence = choice => {
  cadenceButtons.forEach(option => option.setAttribute('aria-checked', String(option === choice)));

  ['price', 'was', 'off', 'each', 'terms'].forEach(name => {
    const value = choice.dataset[`cad${name[0].toUpperCase()}${name.slice(1)}`];
    setText(`[data-sub-${name}]`, value);
  });

  /* what you are charged today belongs to the option, not to a display node —
     it has to survive a switch to one-time and back */
  if (subscribeOption) {
    subscribeOption.dataset.planToday = choice.dataset.cadToday;
    subscribeOption.dataset.planDays = choice.dataset.cadDays;
    applyPlan(subscribeOption);
  }
};

planButtons.forEach(button => button.addEventListener('click', () => applyPlan(button)));
cadenceButtons.forEach(choice => choice.addEventListener('click', () => applyCadence(choice)));

[[planButtons, applyPlan], [cadenceButtons, applyCadence]].forEach(([group, apply]) => {
  group.forEach(node => node.addEventListener('keydown', event => {
    if (!['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].includes(event.key)) return;
    event.preventDefault();
    const step = event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1;
    const next = group[(group.indexOf(node) + step + group.length) % group.length];
    next.focus();
    apply(next);
  }));
});

document.querySelectorAll('a[href="#"]').forEach(link => link.addEventListener('click', event => event.preventDefault()));

/* ── sticky mobile buy bar ──────────────────────────────── */
const sticky = document.querySelector('[data-sticky]');
const hero = document.querySelector('.hero');
const buySection = document.querySelector('.buy');
const footer = document.querySelector('.footer');

if (sticky && 'IntersectionObserver' in window) {
  /* pages without a hero (the product page opens straight onto the offer)
     count as already past it, or the bar would never appear */
  const state = { pastHero: !hero, atBuy: false, atFooter: false };
  const paint = () => sticky.classList.toggle('is-visible', state.pastHero && !state.atBuy && !state.atFooter);

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.target === hero) state.pastHero = !entry.isIntersecting;
      if (entry.target === buySection) state.atBuy = entry.isIntersecting;
      if (entry.target === footer) state.atFooter = entry.isIntersecting;
    });
    paint();
  });

  [hero, buySection, footer].forEach(node => node && observer.observe(node));
}

})();
